<template>
  <div class="sm:w-full md:w4/5 lg:w-3/5 mx-auto md:p-6">
    <div class="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
      <!-- Header -->
      <div class="bg-gradient-to-r from-red-500 to-pink-500 px-6 py-4">
        <h2 class="text-xl font-semibold text-white">Save Gifts</h2>
        <p class="text-red-100 text-sm mt-1">Save {{ gift.name }} for...</p>
      </div>

      <div class="p-6">
        <!-- Empty State -->
        <div v-if="friends.length === 0" class="text-center py-8">
          <div class="text-gray-400 text-5xl mb-4">👥</div>
          <h4 class="text-lg font-medium text-gray-600 mb-2">No friends or family yet</h4>
          <p class="text-gray-500 mb-6">
            You need to add some friends or family members before you can save gifts for them.
          </p>
          <button
@click="$router.push(`/people`)" type="button"
            class="inline-flex items-center px-4 py-2 bg-green-600 text-white text-sm font-medium rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 transition-colors"
>
            <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
            Add People
          </button>
        </div>

        <!-- Friends Grid -->
        <div v-else class="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div v-for="friend in friends" :key="friend.id" class="relative">
            <input
@change="UpdateFriendLink($event, gift.id, friend.GiftLink.items)" type="checkbox"
              :id="friend.id + gift.id" :value="friend.id" :checked="ContainsItem(friend.GiftLink.items, gift.id)"
              class="hidden peer"
/>
            <label
:for="friend.id + gift.id"
              class="flex items-center p-4 bg-gray-50 border-2 border-gray-200 rounded-xl cursor-pointer transition-all duration-200 hover:bg-gray-100 hover:border-gray-300 peer-checked:bg-green-50 peer-checked:border-green-500 peer-checked:text-green-900"
>
              <div class="flex items-center space-x-3 w-full">
                <!-- Avatar -->
                <div
                  class="w-10 h-10 bg-gradient-to-br from-blue-400 to-purple-500 rounded-full flex items-center justify-center text-white font-semibold text-sm"
>
                  {{ friend.name.charAt(0).toUpperCase() }}
                </div>

                <!-- Friend Info -->
                <div class="flex-1 min-w-0">
                  <p class="font-semibold text-gray-900 capitalize truncate">
                    {{ friend.name.toLowerCase() }}
                  </p>
                  <p v-if="friend.email" class="text-sm text-gray-500 truncate">
                    {{ friend.email.toLowerCase() }}
                  </p>
                </div>

                <!-- Checkmark -->
                <div class="flex-shrink-0 opacity-0 peer-checked:opacity-100 transition-opacity">
                  <svg class="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                    <path
fill-rule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clip-rule="evenodd"
/>
                  </svg>
                </div>
              </div>
            </label>
          </div>
        </div>

        <!-- Selected Count -->
        <div v-if="friends.length > 0" class="mt-6 pt-4 border-t border-gray-200">
          <p class="text-sm text-gray-600 text-center">
            {{ selectedCount }} of {{ friends.length }}
            {{ selectedCount === 1 ? 'person' : 'people' }} selected
          </p>
        </div>

        <!-- Back Button -->
        <div class="mt-6 pt-4 border-t border-gray-200">
          <button
type="button" @click="$router.go(-1)"
            class="px-6 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-200 transition-colors duration-200"
>
            Back to Gifts
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { API } from 'aws-amplify';

import { createGiftFriend, deleteGiftFriend } from '../graphql/mutations';

export default {
  name: "GiftAssignModal",
  props: {
    gift: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
    }
  },
  computed: {
    friends() {
      return this.$store.state.friendMap;
    },
    selectedCount() {
      if (!this.friends.length) return 0;
      return this.friends.filter(friend =>
        this.ContainsItem(friend.GiftLink.items, this.gift.id)
      ).length;
    }
  },
  created() {
    this.getFriends();
  },
  methods: {
    async UpdateFriendLink(e, giftID, map) {
      if (e.target.checked) {
        try {
          const giftFriend = { friendId: e.target.value, giftId: giftID };
          const response = await API.graphql({ query: createGiftFriend, variables: { input: giftFriend }, });

          // Update local store data immediately
          const createdGiftFriend = response.data.createGiftFriend;
          const friends = [...this.$store.state.friendMap];
          const friendIndex = friends.findIndex(f => f.id === e.target.value);
          if (friendIndex !== -1) {
            friends[friendIndex].GiftLink.items.push(createdGiftFriend);
            this.$store.dispatch("updateFriends", friends);
          }
        } catch (error) {
          console.log('Error creating gift...', error)
        }
      } else {
        try {
          var giftLinkId = "";
          map.forEach((value) => {
            if (value.gift.id === giftID) {
              giftLinkId = value.id;
            };
          });
          const mutationInput = { "id": giftLinkId };
          const response = await API.graphql({ query: deleteGiftFriend, variables: { input: mutationInput }, });

          // Update local store data immediately
          const friends = [...this.$store.state.friendMap];
          const friendIndex = friends.findIndex(f => f.id === e.target.value);
          if (friendIndex !== -1) {
            friends[friendIndex].GiftLink.items = friends[friendIndex].GiftLink.items.filter(
              item => item.id !== giftLinkId
            );
            this.$store.dispatch("updateFriends", friends);
          }
        } catch (error) {
          console.log('Error deleting gift...', error)
        }
      }
    },
    ContainsItem(map, item) {
      let found = false;
      map.forEach((value) => {
        if (value.gift.id === item) {
          found = true;
        };
      });
      return found;
    },
    async getFriends() {
      const query = `query MyQuery {
  listFriends {
    items {
      id
      name
      email
      birthday
      reminder
      anniversary
      anniversaryReminder
      updatedAt
      GiftLink {
        items {
          id
          createdAt
          updatedAt
          gift {
            name
            id
            price
            url
            image
            description
          }
        }
      }
    }
  }
}`
      let friends = await API.graphql({
        query: query
      });
      var sortedFriends = friends.data.listFriends.items.sort(
        function (a, b) {
          let nameA = a.name.toUpperCase();
          let nameB = b.name.toUpperCase();

          if (nameA < nameB) {
            return -1;
          }

          if (nameA > nameB) {
            return 1;
          }
        }
      );
      this.$store.dispatch("updateFriends", sortedFriends);
    },
  },
};
</script>
